import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon35: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 19.0

  const originalHeight = 20.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 19 20" width={width} height={height} {...props}>
      <Path
        d="M9.49899 0C13.089 0 16 2.901 16 6.48L16.001 8.036C17.696 8.279 19 9.737 19 11.5C19 13.309 17.627 14.798 15.866 14.981C15.469 16.731 14.205 18.185 12.501 18.805V19.5C12.501 19.777 12.277 20 12.001 20H9.254C8.285 20 7.50101 19.217 7.50101 18.25C7.50101 17.284 8.285 16.5 9.254 16.5H12.001C12.277 16.5 12.501 16.724 12.501 17V17.724C13.998 17.027 15 15.505 15 13.798V6.48C15 3.454 12.538 1 9.49899 1C6.46199 1 4 3.454 4 6.48V14.5C4 14.776 3.776 15 3.5 15L3.30801 14.995C1.46401 14.895 0 13.369 0 11.5C0 9.737 1.304 8.278 3 8.035V6.48C3 2.901 5.90999 0 9.49899 0ZM11.501 17.5H9.254C8.837 17.5 8.50101 17.836 8.50101 18.25C8.50101 18.664 8.837 19 9.254 19H11.501V17.5ZM3.00101 9.05C1.85901 9.281 1 10.29 1 11.5C1 12.71 1.85901 13.719 3.00101 13.95V9.05ZM16 9.05V13.95C17.141 13.718 18 12.709 18 11.5C18 10.291 17.141 9.282 16 9.05Z"
        fill="#4775FF"
      />
    </Icon>
  )
}
